


import {SystemDataVM} from './SystemDataVM';
export class CurrencyVM extends SystemDataVM {
    
    code?: string;
    
}
